var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cus-chat-view" }, [
    _c(
      "div",
      { staticClass: "cus-chat-view-search" },
      [
        _c(
          "el-radio-group",
          {
            staticStyle: { "margin-right": "10px" },
            attrs: { size: "small" },
            on: { change: _vm.selectSearchType },
            model: {
              value: _vm.radio,
              callback: function($$v) {
                _vm.radio = $$v
              },
              expression: "radio"
            }
          },
          [
            _c("el-radio-button", { attrs: { label: "今日" } }),
            _c("el-radio-button", { attrs: { label: "昨日" } }),
            _c("el-radio-button", { attrs: { label: "近7日" } }),
            _c("el-radio-button", { attrs: { label: "近30日" } })
          ],
          1
        ),
        _c("el-date-picker", {
          staticStyle: {
            width: "240px",
            "margin-right": "10px",
            padding: "2px 10px"
          },
          attrs: {
            size: "small",
            type: "daterange",
            editable: false,
            "value-format": "yyyy-MM-dd",
            "range-separator": "~",
            "start-placeholder": "开始日期",
            "end-placeholder": "结束日期"
          },
          on: { change: _vm.selectDate },
          model: {
            value: _vm.searchDate,
            callback: function($$v) {
              _vm.searchDate = $$v
            },
            expression: "searchDate"
          }
        })
      ],
      1
    ),
    _c("div", { staticClass: "below" }, [
      _c(
        "div",
        { staticStyle: { flex: "8", height: "600px" } },
        [_c("GroupChatTypeLayout", { ref: "GroupChatTypeLayoutRef" })],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }